import { createCsrfMiddleware, createStart } from '@tanstack/react-start';

import { adAttributionMiddleware } from '@/middleware/ad-attribution';

const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === 'serverFn',
});

/**
 * TanStack Start's global request-middleware entry point. Unlike the
 * `middleware: [...]` arrays wired into individual route groups (see
 * `routes/api.ts`, `routes/v4.ts`), anything registered here runs on every
 * incoming request the server handles — document navigations and server
 * functions alike, with no route or auth scoping. That's required for
 * PX-270's ad-attribution capture: it has to see the public, unauthenticated
 * screener-apply routes, which are the primary ad landing pages.
 */
export const startInstance = createStart(() => ({
  requestMiddleware: [csrfMiddleware, adAttributionMiddleware],
}));
